import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { Heading } from '@ziynx/components/typography';
import {
  Table, TableHead, TableBody, TableHeader, Cell, TableRow,
} from '@ziynx/components/tables';
// import * as KrispyTokens from '@krispy-tokens/blue';

const ContentWrapper = styled.div`
  overflow: scroll;
  width: 1300px; 
  height: 100%;
  padding: 0px 16px;
`;

const tableData = {
  categories: [
    { title: 'Name', value: 'name' },
    { title: 'ID', value: 'id' },
    { title: 'Company', value: 'company' },
    { title: 'Role', value: 'role' },
    { title: 'Location', value: 'location' },
  ],
  items: [
    {
      name: 'Bryan',
      id: '#123456',
      company: 'Mean Guppy',
      role: 'Developer',
      location: 'Remote',
    },
    {
      name: 'Dom',
      id: '#234567',
      company: 'Mean Guppy',
      role: 'Developer',
      location: 'Buffalo, NY',
    },
    {
      name: 'Arthur',
      id: '#345678',
      company: 'Mean Guppy',
      role: 'Developer',
      location: 'Remote',
    },
    {
      name: 'Peter',
      id: '#456789',
      company: 'Daily Bugle',
      role: 'Photogrpher',
      location: 'NYC, NY',
    },
    {
      name: 'Elon',
      id: '#567890',
      company: 'Tesla',
      role: 'CEO',
      location: 'Austin, TX',
    },
  ],
};

const _renderCells = (item) => tableData.categories.map((category, i) => (
  <Cell key={`${i}${item[category.value]}`}>{item[category.value]}</Cell>
));

const _renderTableHeader = () => tableData.categories.map((item, i) => (
  <TableHeader key={i + item.title}>{item.title}</TableHeader>
));

function _renderTableBody() {
  return tableData.items.map((item) => <TableRow>{_renderCells(item)}</TableRow>);
}

const CompanyList = () => (
  <>
    <Helmet>
      <title>
        Company List | ZIYNX Admin
      </title>
    </Helmet>
    <ContentWrapper>
      <Heading large>Company list</Heading>
      <Table>
        <TableHead>{_renderTableHeader()}</TableHead>
        <TableBody>{_renderTableBody()}</TableBody>
      </Table>
    </ContentWrapper>
  </>
);

export default CompanyList;
